import type { ReactNode } from 'react';
import type { Prettify } from '../../../../lib/typeUtils';
import type { Feature } from '../../../canvas/core';
import type { PageId } from '../coordinates/geometry';
import type { PageDimensions } from '../layout/types';

export type TransformContribution<TState = unknown> = {
  getEffectiveDimensions: (
    pageId: PageId,
    baseDims: PageDimensions,
    state: TState
  ) => PageDimensions;

  Wrapper: React.FC<{ pageId: PageId; children: ReactNode }>;

  order: number;
};

export type DocumentFeature<
  TDeps extends Record<string, unknown> = Record<string, never>,
  TSlice extends Record<string, unknown> = Record<string, never>,
> = Prettify<
  Feature<TDeps, TSlice> & {
    transformContribution?: TransformContribution<TDeps & TSlice>;
  }
>;

export const hasTransformContribution = (
  feature: unknown
): feature is { transformContribution: TransformContribution } =>
  typeof feature === 'object' &&
  feature !== null &&
  'transformContribution' in feature &&
  (feature as { transformContribution?: unknown }).transformContribution !==
    undefined;
